import React, { useEffect, useState } from "react";
import { Switch, Button, Input } from "@fluentui/react-components";
import { Delete20Regular } from "@fluentui/react-icons";
import SearchResourceInGraph from "../GenericComponent/SearchResourceInGraph";
import { ConfirmAlert } from "../GenericComponent/ConfirmAlert";
import { useTranslation } from "react-i18next";
import "../CSS/RecordingComponent.css";

export default function RecordingComponent(props) {
  const { t } = useTranslation();
  const { permissions, isEditMode } = props;

  const [callRecordingEnabled, setCallRecordingEnabled] = useState(
    props.callFlowData.callRecordingEnabled || false
  );
  const [selectedReaders, setSelectedReaders] = useState(
    props.callFlowData.callRecordingReaders || []
  );
  const [readersDetails, setReadersDetails] = useState(
    props.callFlowData.callRecordingReadersDetails || {}
  );
  const [selectedReaderToDelete, setSelectedReaderToDelete] = useState(null);

  // Transcription states
  const [audioTranscribeEnabled, setAudioTranscribeEnabled] = useState(
    props.callFlowData.audioTranscribeEnabled || false
  );
  const [audioTranscribeDetails, setAudioTranscribeDetails] = useState(
    props.callFlowData.audioTranscribeDetails || ""
  );

  useEffect(() => {
    setCallRecordingEnabled(props.callFlowData.callRecordingEnabled || false);
    setSelectedReaders(props.callFlowData.callRecordingReaders || []);
    setReadersDetails(props.callFlowData.callRecordingReadersDetails || {});
    setAudioTranscribeEnabled(props.callFlowData.audioTranscribeEnabled || false);
    setAudioTranscribeDetails(props.callFlowData.audioTranscribeDetails || "");
  }, [props.callFlowData]);

  const handleToggleChange = (e, val) => {
    setCallRecordingEnabled(val);
    props.setCallFlowData((prev) => ({ ...prev, callRecordingEnabled: val }));
  };

  const handleResourceSelect = (resource) => {
    if (!resource?.id || !resource?.displayName) return;

    const newReaders = [...selectedReaders];
    const newDetails = { ...readersDetails };

    if (!newReaders.includes(resource.id)) {
      newReaders.push(resource.id);
      newDetails[resource.id] = resource.displayName;
    }

    setSelectedReaders(newReaders);
    setReadersDetails(newDetails);

    props.setCallFlowData((prev) => ({
      ...prev,
      callRecordingReaders: newReaders,
      callRecordingReadersDetails: newDetails,
    }));
  };

  const confirmRemove = (id) => setSelectedReaderToDelete(id);

  const removeReader = () => {
    if (!selectedReaderToDelete) return;

    const newReaders = selectedReaders.filter((r) => r !== selectedReaderToDelete);
    const newDetails = { ...readersDetails };
    delete newDetails[selectedReaderToDelete];

    setSelectedReaders(newReaders);
    setReadersDetails(newDetails);
    props.setCallFlowData((prev) => ({
      ...prev,
      callRecordingReaders: newReaders,
      callRecordingReadersDetails: newDetails,
    }));

    setSelectedReaderToDelete(null);
  };

  // Transcription handlers
  const handleTranscribeToggle = (e, val) => {
    setAudioTranscribeEnabled(val);
    props.setCallFlowData((prev) => ({ ...prev, audioTranscribeEnabled: val }));
  };

  const handleTranscribeDetailsChange = (e) => {
    const value = e.target.value;
    setAudioTranscribeDetails(value);
    props.setCallFlowData((prev) => ({ ...prev, audioTranscribeDetails: value }));
  };

  return (
    <div className="recording-container">
      {/* Left Column: Recording */}
      <div className="recording-column">
        <div className="recording-switch">
          <label>{t("enableRecording")}</label>
          <Switch
            checked={callRecordingEnabled}
            disabled={isEditMode ? !permissions?.recording?.canUpdate : !permissions?.recording?.canCreate}
            onChange={(e, data) => handleToggleChange(e, data.checked)}
          />
        </div>
{
/**
 {callRecordingEnabled && (
          <>
            <div className="recording-input-wrapper">
              <SearchResourceInGraph displayName="" onSelectUser={handleResourceSelect} disabled={isEditMode ? !permissions?.recording?.canUpdate : !permissions?.recording?.canCreate} />
            </div>

            <div className="recording-readers-list">
              <p>{t("recordingReaders")}</p>
              <ul>
                {selectedReaders.map((id) => (
                  <li key={id} className="recording-reader-item">
                    <span>{readersDetails[id]}</span>
                    <Button
                      icon={<Delete20Regular />}
                      appearance="subtle"
                      disabled={!permissions?.recording?.canDelete}
                      onClick={() => confirmRemove(id)}
                    />
                  </li>
                ))}
              </ul>
            </div>
          </>
        )}
 */
}
        
      </div>

      {/* Right Column: Transcription */}
      {callRecordingEnabled && (
        <div className="recording-column">
          <div className="recording-transcribe-header">
            <label>{t("webServiceTranscription")}</label>
            <Switch
              checked={audioTranscribeEnabled}
              disabled={isEditMode ? !permissions?.recording?.canUpdate : !permissions?.recording?.canCreate}
              onChange={(e, data) => handleTranscribeToggle(e, data.checked)}
            />
          </div>
{
  /**
   {audioTranscribeEnabled && (
            <div className="recording-transcribe-details">
              <Input
              style={{ width: '53%' }}
                placeholder={t("transcriptionDetails")}
                value={audioTranscribeDetails}
                disabled={isEditMode ? !permissions?.recording?.canUpdate : !permissions?.recording?.canCreate}
                onChange={handleTranscribeDetailsChange}
              />
            </div>
          )}
   */
}
          
        </div>
      )}

      {selectedReaderToDelete && (
        <ConfirmAlert
          open={!!selectedReaderToDelete}
          name={readersDetails[selectedReaderToDelete]}
          onConfirm={removeReader}
          onCancel={() => setSelectedReaderToDelete(null)}
        />
      )}
    </div>
  );
}
